import { useNavigate } from "react-router-dom"
import useGlobalContext from "../context/GlobalContext"
import { motion } from "framer-motion"

const SliderImg = ({ proj }) => {
  const navigate = useNavigate()
  const { changeCursor } = useGlobalContext()

  const handleChange = () => {
    navigate(`/work/${proj.title}`, { state: { proj } })
  }

  return (
    <motion.div onClick={handleChange} className="slider-img p-relative">
      <motion.picture
        onMouseEnter={() => changeCursor("img-hover")}
        onMouseLeave={() => changeCursor("")}
      >
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0, transition: { duration: 1 } }}
          className="par uppercase float-txt mix-blend-difference"
        >
          {proj.title}
        </motion.p>
        <source type="" media="(min-width:768px)" srcSet={proj.img}></source>
        <source srcSet={proj.imgSm}></source>
        <motion.img loading="lazy" src={proj.img} alt="" decoding="async" />
      </motion.picture>
    </motion.div>
  )
}

export default SliderImg
